import styled from 'styled-components';

// Ported from `ui/paradex/src/assets/SignoutIcon.tsx`. The original uses
// absolute transforms inherited from its Sketch artboard; preserving them
// keeps the glyph identical to what users see in the Paradex sub-accounts
// screen. Stroke uses `currentColor` so the danger menu item paints it red.
const LogoutIconSvg = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

// viewBox padded to a square (`-1.5 0 17 17`) so a 16×16 box renders the
// 14×17 glyph without horizontal squish.
export default function LogoutIcon() {
  return (
    <LogoutIconSvg viewBox="-1.5 0 17 17" aria-hidden="true">
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g transform="translate(-1266, -151)" stroke="currentColor">
          <g transform="translate(1249, 71.5)">
            <g transform="translate(17.6434, 80.5)">
              <path
                d="M10.8259291,4.17407091 L10.8259291,8.14032909 C10.8259291,9.63232909 9.70692909,10.8259291 8.30817909,10.8259291 L-1.65630727,10.8259291 C-3.04174136,10.8259291 -4.17407091,9.61807455 -4.17407091,8.14032909 L-4.17407091,4.17407091"
                transform="translate(3.3259, 7.5) rotate(-270) translate(-3.3259, -7.5)"
              />
              <g transform="translate(4.9809, 4.2319)">
                <line
                  x1="3.79904586"
                  y1="7.08159132"
                  x2="3.79904586"
                  y2="-0.516500407"
                  transform="translate(3.799, 3.2825) scale(-1, 1) rotate(-450) translate(-3.799, -3.2825)"
                />
                <polyline
                  transform="translate(6.0835, 3.2753) scale(-1, 1) rotate(-270) translate(-6.0835, -3.2753)"
                  points="2.80817697 1.64830909 6.06217697 4.91652727 9.35883152 1.63412727"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </LogoutIconSvg>
  );
}
